<template>
  <div>
    <v-btn class="mx-2" dark icon @click="openActionMenu()">
      <v-icon color="grey">mdi-menu</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({}),
    beforeCreate() {},
    mounted() {},
    methods: {
      openActionMenu() {
        this.$store.dispatch("agGrid/setAGGridActionMenuState", this.params.data);
      },
    },
  };
</script>